import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type {
    DoorDashContactDraft,
    DoorDashContactDrafts
} from '~/components/DoorDash/types';
import { resetOnLogout } from './common-actions';
import { setMainClient, resetMainClient } from './mainClientSlice';
import {
    setSelectedClients,
    resetSelectedClients
} from './selectedClientsSlice';

export type { DoorDashContactDrafts } from '~/components/DoorDash/types';
const initialState = {
    byClient: {} as DoorDashContactDrafts,
    mainClientId: '',
    selectedClientIds: ''
};

// Intentionally excluded from redux-persist: contact corrections are session drafts,
// never task/customer updates, and client switches/logout discard them.
export const doorDashContactDraftsSlice = createSlice({
    name: 'doorDashContactDrafts',
    initialState,
    reducers: {
        saveDoorDashContactDraft: (
            state,
            {
                payload
            }: PayloadAction<{
                clientId: string;
                taskId: string;
                contact: DoorDashContactDraft;
            }>
        ) => {
            if (!payload.clientId || !payload.taskId) return;
            const drafts = state.byClient[payload.clientId] ?? {};
            drafts[payload.taskId] = payload.contact;
            state.byClient[payload.clientId] = drafts;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(resetOnLogout, () => initialState)
            .addCase(resetMainClient, () => initialState)
            .addCase(resetSelectedClients, () => initialState)
            .addCase(setMainClient, (state, { payload }) => {
                const clientId = payload?.id ?? '';
                if (clientId !== state.mainClientId) state.byClient = {};
                state.mainClientId = clientId;
            })
            .addCase(setSelectedClients, (state, { payload }) => {
                const clientIds = [...new Set<string>(payload)]
                    .sort()
                    .join('|');
                if (clientIds !== state.selectedClientIds) state.byClient = {};
                state.selectedClientIds = clientIds;
            });
    }
});
export const { saveDoorDashContactDraft } = doorDashContactDraftsSlice.actions;
